import { GridItem, Grid, Text } from "@chakra-ui/react"
import React, { ReactNode } from "react"
import ActionButton from "./ActionButton"

type Props = {
  title: ReactNode
  buttonClick: (() => void) | null
  actionText: string
  rsvpButtonColor: string
}

const WebsiteHeader = ({
  title,
  buttonClick,
  actionText,
  rsvpButtonColor,
}: Props) => (
  <Grid
    alignItems="center"
    zIndex={1}
    w="100%"
    templateColumns="repeat(6, 1fr)"
    gap={4}
  >
    <GridItem
      colSpan={{ base: 6, lg: 5 }}
      textAlign={{ base: "center", lg: "left" }}
    >
      <Text fontSize="3xl" fontWeight="semibold">
        {title}
      </Text>
    </GridItem>
    {buttonClick && (
    <GridItem
      display={{ base: "none", lg: "block" }}
      colSpan={{ base: 6, lg: 1 }}
      textAlign={{ base: "center", lg: "right" }}
    >
      <ActionButton
        text={actionText}
        color={rsvpButtonColor}
        buttonClick={buttonClick}
        minW="320px"
      />
    </GridItem>
    )}
  </Grid>
)

export default WebsiteHeader
